const state = {
  current: {},
}

const actions = {
  async getCurrent({ commit }, id) {
    await this._vm.$api.get(`customers/${id}/get`).then((res) => {
      commit('SET_CURRENT', res.data)
      return res
    })
  },
}

const mutations = {
  SET_CURRENT(state, payload) {
    state.current = payload
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
